import { useEffect } from 'react';
import Client from './api-client';
import { useUserStore } from './User.Store';
import { usePrintJobStore } from './PrintJob.Store';
import { useOrderStore } from './Order.Store';
import { useProductStore } from './Product.Store';
import { useDesignStore } from './Design.Store';
import { useInstaceStore } from './Instance.Store';
import { useShopStore } from './Shop.Store';
import { useStickerStore } from './Sticker.Store';
import { usePaymentStore } from './Payment.Store';
import RequestUtils from './api-client/Request.utils';

// default to 'http://localhost:3000'
Client.setHost('http://localhost:3000');
// Client.setHost('https://dev.bg-production.personify.tech');

if (process.env.NODE_ENV !== 'development') {
  if (window.location.hostname.includes('dev.bg-production.personify.tech')
    || window.location.hostname.includes('bg-dev.bottledgoose.co.uk')
  ) {
    Client.setHost('https://dev.bg-production.personify.tech');
  } else {
    Client.setHost('https://bg-production.personify.tech');
  }
}

export const Store = {
  Client,
  Api: Client.Api,
  useUserStore,
  usePrintJobStore,
  useOrderStore,
  useProductStore,
  useDesignStore,
  useInstaceStore,
  useShopStore,
  useStickerStore,
  usePaymentStore,
}

// @ts-ignore
window.PMApi = Client.Api;
export const Api = Client.Api;

export default Store;

export const Request = RequestUtils;
